import { render, staticRenderFns } from "./MatchingRequest.vue?vue&type=template&id=79e694b3&scoped=true&"
import script from "./MatchingRequest.vue?vue&type=script&lang=ts&"
export * from "./MatchingRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e694b3",
  null
  
)

export default component.exports